module.exports = __webpack_public_path__ + "static/media/adVector.f259b774.svg";